/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatCal = require('../types/NatCal')
const CAbscisseOrigineRep = require('./CAbscisseOrigineRep')
const CValDyn = require('./CValDyn')
module.exports = CUniteyRep
/**
 * Calcul renvoyant comme valeur l'unité d'un repère sur l'axe des ordonnées.
 * @constructor
 * @extends mtg32.CAbscisseOrigineRep
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {String} nomCalcul : Le nom du calcul.
 * @param {CRepere} rep : Le repère associé.
 * @returns {CUniteyRep}
 */
function CUniteyRep (listeProprietaire, impProto, estElementFinal, nomCalcul, rep) {
  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);
  else {
    CAbscisseOrigineRep.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, rep);
  }
}
CUniteyRep.prototype = new CAbscisseOrigineRep();
CUniteyRep.prototype.constructor = CUniteyRep;
CUniteyRep.prototype.superClass = "CAbscisseOrigineRep";
CUniteyRep.prototype.className = "CUniteyRep";

CUniteyRep.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.rep);
  var ind2 = listeSource.indexOf(this.impProto);
  return new CUniteyRep(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CRepere"));
};
CUniteyRep.prototype.getNatureCalcul = function() {
  	return NatCal.NUniteyRep;
};
CUniteyRep.prototype.positionne = function(infoRandom, dimfen) {
  this.existe = this.rep.existe;
  this.abscisseOrigine = this.rep.unitey;
};



// WEBPACK FOOTER //
// ./src/objets/CUniteyRep.js